export enum ReactionType{
    VOTE = 1,
    LIKE = 2,
    CARE = 3,
    HEART = 4,
    HAHA = 5,
    WOW = 6
}